import { useState, createContext, useContext } from "react";

const CategoryDataContext = createContext();
// const UpdateCategoryDataContext = createContext();

export const useCategoryDataContext = () => {
    return useContext(CategoryDataContext);
};

// export const useUpdateCategoryDataContext = () => {
//     return useContext(UpdateCategoryDataContext);
// };

const CategoryDataProvider = ({value, children}) => {
    const [categoryData, setcategoryData] = useState(value);
    return (
        <CategoryDataContext.Provider value={categoryData}>
            {/* <UpdateCategoryDataContext.Provider value={setCommandSpell}> */}
                {children}
            {/* </UpdateCategoryDataContext.Provider> */}
        </CategoryDataContext.Provider>
    );
}

export default CategoryDataProvider;